import React, { FC, useState, useEffect } from 'react'
import { IonInput, IonModal, IonContent, useIonViewWillEnter } from '@ionic/react'
import { observer } from 'mobx-react'
import { MktButton, UseHeader } from '@cps'
import i18n from 'i18next'
import { ddayjs } from '@dt/fe-utils'
import { toast, formatCardNumber } from '@utils'
import { memberMobx } from '@mobxStore'
import { getGiftCardName } from '@common/utils/giftcard'
import './index.scss'

interface IProps {
  reject: () => void;
  resolve: () => void;
}

interface IState {
  cardNo: string;
  cardPin: string;
}

const BindGiftCardModal: FC<IProps> = (props) => {
  const {
    reject,
    resolve,
  } = props
  const initialState: IState = {
    cardNo: '',
    cardPin: ''
  }
  const { bindingGiftCard } = memberMobx
  const [cardNo, setCardNo] = useState<string>(initialState.cardNo)
  const [cardPin, setCardPin] = useState<string>(initialState.cardPin)
  let posting = false
  const handleBinding = async () => {
    if (!cardNo || !cardPin) {
      toast({ message: i18n.t('mkt.common.tipCardNumber') })
      return
    }
    const cardRes: any = await memberMobx.getMemberGiftCardDetail({ cardNo })
    if (!cardRes) {
      toast({ message: i18n.t('mkt.giftCard.invalidCardInfo') })
      return
    }
    if (cardRes && cardRes.memberId) {
      toast({ message: i18n.t('mkt.giftCard.cardIsBind') })
      return
    }
    if (cardRes.status !== 'enable') {
      toast({ message: i18n.t('mkt.giftCard.cardIsFrozen') })
      return
    }
    if (cardRes.expireTime && ddayjs(cardRes.expireTime).valueOf() <= Date.now()) {
      toast({ message: i18n.t('mkt.giftCard.status_expired') })
      return
    }
    if (posting) return
    posting = true
    bindingGiftCard({ cardNo, cardPin }).then((res: any) => {
      if (res) {
        toast({ message: i18n.t('mkt.giftCard.bindSuccess') })
        resolve && resolve()
      }
      posting = false
    }).catch(() => {
      posting = false
    })
  }
  useIonViewWillEnter(() => {
    setCardNo(initialState.cardNo)
    setCardPin(initialState.cardPin)
  },)
  return (
    <IonModal
      cssClass='bind-giftcard-modal'
      isOpen
      onDidDismiss={reject}
    >
      <UseHeader onBack={reject} title={getGiftCardName('mkt.giftCard.bind', 'mkt.giftCard.bindCustom')}></UseHeader>
      <IonContent>
        <div className='modal-content'>
          <div className='mkt-input'>
            <IonInput data-cypid='mmgGCardNoInput' maxlength={20} value={cardNo} placeholder={i18n.t('mkt.giftCard.enterCardNo')} onIonChange={(e: any) => setCardNo(formatCardNumber(e.detail.value))} />
          </div>
          <div className='input-item'>
            <div className='mkt-input'>
              <IonInput data-cypid='mmgGCardPwdInput' maxlength={6} value={cardPin} placeholder={i18n.t('mkt.giftCard.tipCardPin')} onIonChange={(e: any) => setCardPin(e.detail.value)} />
            </div>
          </div>
          <div className='btn-area'>
            <MktButton text={i18n.t('mkt.common.bind')} disabled={!cardNo || !cardPin} onClick={handleBinding}></MktButton>
          </div>
        </div>
      </IonContent>
    </IonModal>
  )
}

export default observer(BindGiftCardModal)
